module.exports = __webpack_public_path__ + "static/media/mail-icon--red--filled.267c9b1e.svg";